export default __webpack_public_path__ + "static/media/todayorders.c0543ebb.svg";